module.exports = __webpack_public_path__ + "img/img-009be7.png";